import React, { useCallback, useContext } from "react";
import { Card } from "primereact/card";
import { useToast } from "@/providers";
import { FormSignIn } from "./FormSignIn/FormSignIn";
import { singInSchema } from "./yup-schemas";
import { AuthLocalInput } from "@types";
import { isErrorWithMessage } from "@utils";
import { STRING } from "@constants";
import { ACTIONS, AppContext } from "@/providers/AuthProviders";
import { useLogin } from "@hooks";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "@navigation";

export function SignIn() {
  const { showToast } = useToast();
  const { login, loading } = useLogin();
  const { dispatch } = useContext(AppContext);
  const navigate = useNavigate();

  const handleSubmit = useCallback(
    (values: AuthLocalInput) => {
      login(values)
        .then((res) => {
          dispatch({
            type: ACTIONS.SET_AUTHENTICATED,
            payload: {
              authenticated: true,
            },
          });

          localStorage.setItem("accessToken", res.data.token);
          navigate(`${ROUTES.ADMIN}/${ROUTES.DASHBOARD}`);
        })
        .catch((error) => {
          const errorMessage = isErrorWithMessage(error)
            ? error.message
            : STRING.LOGIN.TOAST_ERROR_DEFAULT;

          showToast({
            severity: "error",
            summary: STRING.LOGIN.TOAST_ERROR_TITLE,
            detail: errorMessage,
            life: 3000,
          });
        });
    },
    [login, dispatch, showToast, navigate],
  );

  return (
    <div className="login-container flex align-items-center justify-content-center p-4">
      <div className="w-full max-w-md fade-in">
        <Card className="login-card p-6">
          <div className="text-center mb-6">
            <div className="logo-container mb-3">
              <i className="pi pi-shield text-6xl"></i>
            </div>
            <h1 className="text-3xl font-bold text-900 mb-2">
              {STRING.LOGIN.TITLE}
            </h1>
            <p className="welcome-text text-lg">{STRING.LOGIN.SUBTITLE}</p>
          </div>

          <FormSignIn
            onSubmit={handleSubmit}
            validationSchema={singInSchema}
            loading={loading}
          />
        </Card>
      </div>
    </div>
  );
}
